import { fromJS, Set } from 'immutable';
import { SEARCH_RESET, SEARCH_UPDATE, SEARCH_SET, SEARCH_TOGGLE } from '@instructure/quiz-common';
var defaultState = fromJS({
  interactionTypes: Set()
}).set('tags', []);
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SEARCH_RESET:
      return defaultState;
    case SEARCH_UPDATE:
      return state.set('text', action.payload.text);
    case SEARCH_TOGGLE:
      {
        var _action$payload = action.payload,
          filter = _action$payload.filter,
          key = _action$payload.key;
        var prior = state.get(filter, Set());
        var toggled = prior.has(key) ? prior.remove(key) : prior.add(key);
        return state.set(filter, toggled);
      }
    case SEARCH_SET:
      {
        var _action$payload2 = action.payload,
          _filter = _action$payload2.filter,
          value = _action$payload2.value;
        return state.set(_filter, value);
      }
    default:
      return state;
  }
});